import ClaimsSection from '@/features/claims/components/ClaimsSection/ClaimsSection';
import DocumentsSection from '@/features/documents/components/DcoumentsSection/DocumentsSection';
import InvoicesSection from '@/features/invoices/components/InvoicesSection/InvoicesSection';
import NotesSection from '@/features/notes/components/NotesSection/NotesSection';
import PoliciesSection from '@/features/policies/components/PoliciesSection/PoliciesSection';
import RiskObjectsSection from '@/features/risk-objects/components/RiskObjectsSection/RiskObjectsSection';

import RiskScanSection from '../RiskScan/RiskScanSection';

import PartyDetailsSection from './../PartyDetailsSection/PartyDetailsSection';
import MyEnvironmentSection from './MyEnvironmentSection';
import OnlyShowRelevantToggle from './OnlyShowRelevantToggle';

export default function PartyTab() {
  return (
    <div className="flex flex-col">
      <OnlyShowRelevantToggle />

      <div className="p-2.5">
        <PartyDetailsSection />
      </div>

      <div className="flex flex-col border-t">
        <PoliciesSection />

        <InvoicesSection />

        <ClaimsSection />

        <RiskObjectsSection />

        <NotesSection />

        <DocumentsSection />

        <RiskScanSection />

        <MyEnvironmentSection />
      </div>
    </div>
  );
}
